import React from "react";
import sla1 from "./slaDocument1.module.css";
import companyLogo from "./sla1images/logo-mark@2x.png";
import taizoName from "./sla1images/taizoin.svg";
import maskGroup from "./sla1images/mask-group@2x.png";
import locationpin from "./sla1images/locationpinsvgrepocom-1-1.svg";
import landline from "./sla1images/landline-1.svg";
import emailSvg from "./sla1images/emailsvgrepocom-3-1.svg";
import wwwtaizo from "./sla1images/worldwideweb-2-1.svg";

const SLAMiddlePage = ({ companyName ,recruitmentFeePercentage,paymentType}) => {
  return (
    <>
      <div className={sla1["SLADOC"]}>
        <div className={sla1["sla-page-1"]}>
          <section className={sla1["root-f-r-a-m-e-1"]}>
            <header className={sla1["top-level-frame"]}>
              <div className={sla1["logo-frame"]}>
                <div className={sla1["taizo-logomark1"]}>
                  <img
                    className={sla1["logo-mark-icon1"]}
                    alt=""
                    src={companyLogo}
                  />

                  <img
                    className={sla1["taizoin-icon1"]}
                    alt="logo"
                    src={taizoName}
                  />
                </div>
                <div className={sla1["taizo-technologies-private2"]}>
                  Taizo Technologies Private Limited.
                </div>
              </div>
              <div className={sla1["s-l-a-text"]}>
                <div className={sla1["inner-frames"]}></div>
                <div className={sla1["service-frames"]}></div>
              </div>
            </header>
            {/* <div className={sla1["s-l-a-slice"]}>
              <b className={sla1["service-level-agreement"]}>
                Service Level Agreement (SLA) for <br /> {companyName}.
              </b>
            </div> */}
            <div className={sla1["details-f-r-a-m-e-1"]}>
              <div className={sla1["mask-group-holder"]}>
                <img
                  className={sla1["mask-group-icon1"]}
                  loading="eager"
                  alt=""
                  src={maskGroup}
                />

                <div className={sla1["body-text3"]}>
                  <div
                    className={sla1["turnaround-time-for-suitable-c"]}
                    style={{ marginBottom: "10px" }}
                  >
                    <div className={sla1["turnaround-time-for"]}>
                      6. Recruitment Fee Structure:
                    </div>
                    <div className={sla1["taizoin-commits-to-container"]}>
                      <span>
Taizo.in charges <b>{recruitmentFeePercentage}{" "}% of Annual {paymentType} </b> per successfully recruited candidate plus applicable GST.                      </span>
                      {/* <span className={sla1["taizo-testings"]}>
                        {companyName}'s {"  "}
                      </span>
                      <span>
                        job requirements within 5 days from the date of request
                        submission.
                      </span> */}
                    </div>
                  </div>
                  <div
                    className={sla1["dedicated-account-management"]}
                    style={{ marginBottom: "10px" }}
                  >
                    <div className={sla1["dedicated-account-management1"]}>
                      7. Payment Terms:
                    </div>
                    <div className={sla1["a-dedicated-account-container"]}>
                      <span>
                        All payments must follow the monthly billing cycle. Delays beyond agreed payment window may result in temporary pause of hiring services until dues are cleared.
                      </span>
                      {/* Taizo.in
                      <span> and </span>
                      <span className={sla1["taizo-testing2"]}>
                        {companyName}
                      </span>
                      <span> throughout the recruitment process. </span> */}
                    </div>
                  </div>
                  <div
                    className={sla1["tailored-recruitment-services"]}
                    style={{ marginBottom: "10px" }}
                  >
                    <div className={sla1["tailored-recruitment-services1"]}>
                      8. Guarantee and Replacement Policy:
                    </div>
                    <div className={sla1["a-committed-team-container"]}>
                      <span>
                        If a candidate voluntarily leaves within 30 days of joining, Taizo.in will provide one-time replacement without additional recruitment fee. Replacement adjustments will be managed during monthly reconciliation.
                      </span>
                      {/* <span className={sla1["taizo-testings1"]}>
                        {companyName}'s{" "}
                      </span>
                      <span> hiring needs. </span> */}
                    </div>
                  </div>
                  <div
                    className={sla1["candidate-interview-line-up"]}
                    style={{ marginBottom: "10px" }}
                  >
                    <div className={sla1["candidate-interview-line-up1"]}>
                      9. Direct Hiring Protection Clause:
                    </div>
                    <div className={sla1["taizoin-will-arrange-container"]}>
                      <span>If a candidate introduced by Taizo.in joins the Client directly or indirectly within 6 months from introduction date, the recruitment fee shall remain payable to Taizo.in.</span>
                    </div>
                  </div>
                  <div
                    className={sla1["postion-clousure"]}
                    style={{ marginBottom: "10px" }}
                  >
                    <div className={sla1["position-closure"]}>
                      10. Candidate Ownership:
                    </div>
                    <div className={sla1["taizoin-will-work"]}>
                      <span>Candidate ownership remains with Taizo.in for 180 days from first introduction.</span>
                    </div>
                  </div>
                  <div
                    className={sla1["postion-clousure"]}
                    style={{ marginBottom: "10px" }}
                  >
                    <div className={sla1["position-closure"]}>
                      11. Interview Feedback Commitment:
                    </div>
                    <div className={sla1["taizoin-will-work"]}>
                     <span>Client agrees to provide interview feedback within 48 hours to ensure positive candidate experience and hiring efficiency.</span>
                    </div>
                  </div>
                  <div
                    className={sla1["postion-clousure"]}
                    style={{ marginBottom: "10px" }}
                  >
                    <div className={sla1["position-closure"]}>
                     12. Service Pause Rights:
                    </div>
                    <div className={sla1["taizoin-will-work"]}>
                      <span>Taizo.in reserves the right to pause recruitment activities in cases of prolonged feedback delay, payment delays, or repeated hiring misalignment.</span>
                    </div>
                  </div>
                  <div
                    className={sla1["postion-clousure"]}
                    style={{ marginBottom: "10px" }}
                  >
                    <div className={sla1["position-closure"]}>
                     13. Confidentiality:
                    </div>
                    <div className={sla1["taizoin-will-work"]}>
                        <span>Both parties agree to maintain confidentiality of candidate information, business data, and hiring strategies.</span>
                    </div>
                  </div>
                  <div
                    className={sla1["postion-clousure"]}
                    style={{ marginBottom: "10px" }}
                  >
                    <div className={sla1["position-closure"]}>
                     14. Termination:
                    </div>
                    <div className={sla1["taizoin-will-work"]}>
                        <span>Either party may terminate this agreement with 30 days written notice. Outstanding payments remain payable.</span>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className={sla1["company-contact-f-r-a-m-e"]}>
            <div className={sla1["footer-address1"]}>
              <div className={sla1["software-park-text"]}>
                <div className={sla1["software-technology-parks-container1"]}>
                  <p className={sla1["software-technology-parks1"]}>
                    {" "}Software Technology Parks of India,
                  </p>
                  <p className={sla1["nd-floor-no51"]}>
                    2nd Floor, No.5, Rajiv Gandhi Salai, Taramani, Chennai - 600
                    113.
                  </p>
                </div>
                <img
                  className={sla1["location-pin-svgrepo-com-1-11"]}
                  loading="eager"
                  alt=""
                  src={locationpin}
                />{" "}
              </div>
              <div className={sla1["info-frame"]}>
                <div className={sla1["communication-channels"]}>
                  <img
                    className={sla1["landline-1-icon1"]}
                    loading="eager"
                    alt=""
                    src={landline}
                  />

                  <div className={sla1["s-l-a"]}>+91 44 4813 5483</div>
                </div>
                <div className={sla1["communication-channels1"]}>
                  <img
                    className={sla1["email-svgrepo-com-3-11"]}
                    loading="eager"
                    alt=""
                    src={emailSvg}
                  />

                  <div className={sla1["infotaizoin4"]}>info@taizo.in </div>
                </div>
                <div className={sla1["communication-channels2"]}>
                  <img
                    className={sla1["world-wide-web-2-11"]}
                    loading="eager"
                    alt=""
                    src={wwwtaizo}
                  />

                  <div className={sla1["wwwtaizoin1"]}> www.taizo.in</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SLAMiddlePage;
